import logoLight from "@/images/highlanderpro.png";
import logoDark from "@/images/highlanderpro.png";

export const LogoImage = {
    light: logoLight,
    dark: logoDark,
    largeLogo: logoLight,
    smallLogo: logoDark,
};